import type { RecentItem, Suite } from '../../../data/types/platform';

export interface RecentProps {
  recent: RecentItem[];
  suites: Suite[];
  goToSystem: (systemId: string, moduleId?: string) => void;
}

export function Recent({ recent, suites, goToSystem }: RecentProps) {
  return (
    <div className="rail-panel">
      <div className="rp-head">
        <h3>אחרונים</h3>
        <span className="rp-count">היום</span>
      </div>
      {recent.map((r, i) => {
        const suite = suites.find((x) => x.id === r.suite);
        return (
          <div className="recent-row" key={i} onClick={() => goToSystem(r.suite, r.module)}>
            <div>
              <div className="r-name">{r.he}</div>
              <div className="r-suite">{suite?.he}</div>
            </div>
            <div className="r-time">{r.time}</div>
          </div>
        );
      })}
    </div>
  );
}
